import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { RnUsersVM } from '../../../services/rnapi2-service/models/models';
import { OrgRenameUserLoggedInConfig } from './rename-error-config';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { FolderOrgRenameErrorModalService } from './folder-org-rename-error-modal.service';
import { ModalState } from 'src/app/shared/services/base-modal/base-modal.service';

@Component({
  selector: 'app-org-close-folder-rename-error-modal',
  templateUrl: './rename-error.component.html',
  styleUrls: ['./rename-error.component.scss'],
  standalone: false
})
export class OrgRenameUserLoggedInDialogComponent implements OnInit, OnDestroy {
  @ViewChild('modalRef') modal: ModalComponent;
  type: string;
  verb: string;
  usersLoggedIn: RnUsersVM[];
  subscriptions = [];
  private readonly folderOrgRenameErrorModalService = inject(FolderOrgRenameErrorModalService);

  ngOnInit(): void {
    this.subscribeModalService();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  subscribeModalService(): void {
    const sub = this.folderOrgRenameErrorModalService.modalState$.subscribe(
      (data: ModalState<OrgRenameUserLoggedInConfig>) => {
        if (!data?.config) {
          return;
        }
        this.type = data.config.type;
        this.verb = data.config.verb;
        this.usersLoggedIn = data.config.users.sort((u1, u2) => {
          const orgComp = u1.OrganizationName.localeCompare(u2.OrganizationName);
          if (orgComp === 0) {
            return u1.FullName.localeCompare(u2.FullName);
          }
          return orgComp;
        });

        if (data?.isOpen) {
          this.open();
        } else {
          this.close();
        }
      }
    );
    this.subscriptions.push(sub);
  }

  open(): void {
    this.modal?.open();
  }

  close() {
    this.modal?.close();
  }
}
